
import React, { useEffect, useRef, useState } from 'react';
import './Home.css';

const items = [
  
  {
    id: 1,
    type: "video",
    src: "/images/pt2000_bg_video.mp4",
    srcPortrait: "/images/pt2000_bg_video_v.mp4",
    title: "",
    description: "",
    link: "",
  },
  {
    id: 2,
    type: "image",
    src: "/images/pt2000_bg_00.jpg",
    srcPortrait: "/images/pt2000_bg_00_v.jpg",
    alt: "",
    title: "",
    description: "",
    link: "",
  },
  {
    id: 3,
    type: "image",
    src: "/images/pt2000_bg_01.jpg",
    srcPortrait: "/images/pt2000_bg_01_v.jpg",
    alt: "",
    title: "Xem thêm sản phẩm nữ",
    description: "",
    link: "/nu/tat-ca-san-pham-nu.html",
  },
  {
    id: 4,
    type: "image",
    src: "/images/pt2000_bg_02.jpg",
    srcPortrait: "/images/pt2000_bg_02_v.jpg",
    alt: "",
    title: "Xem thêm sản phẩm nam",
    description: "",
    link: "/nam/tat-ca-san-pham-nam.html",
  },
  {
    id: 5,
    type: "image",
    src: "/images/pt2000_bg_03.jpg",
    srcPortrait: "/images/pt2000_bg_03_v.jpg",
    alt: "",
    title: "",
    description: "",
    link: "",
  },
];

const Home = () => {
  const [isPortrait, setIsPortrait] = useState(window.innerHeight > window.innerWidth);
  const containerRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const videoRef = useRef(null);
  const timeoutRef = useRef(null);

  // Resize
  useEffect(() => {
    const handleResize = () => {
      setIsPortrait(window.innerHeight > window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Scroll tracking
  useEffect(() => {
    const handleScroll = () => {
      if (!containerRef.current) return;
      const scrollTop = containerRef.current.scrollTop;
      const index = Math.round(scrollTop / window.innerHeight);
      setActiveIndex(index);
    };

    const container = containerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }

    return () => container?.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const currentItem = items[activeIndex];
    const container = containerRef.current;
    const viewportHeight = window.innerHeight;
  
    const goToNextItem = () => {
      const nextIndex = (activeIndex + 1) % items.length;
      container.scrollTo({
        top: nextIndex * viewportHeight,
        behavior: "smooth",
      });
      setActiveIndex(nextIndex);
    };
  
    if (currentItem.type === "video") {
      const videoEl = videoRef.current;
  
      if (videoEl) {
        // Reset video nếu đã hết
        if (videoEl.ended || videoEl.currentTime >= videoEl.duration - 0.5) {
          videoEl.currentTime = 0;
          videoEl.play().catch((e) => {
            console.warn("Video play error:", e);
          });
        }
  
        // Đảm bảo chỉ add 1 lần
        videoEl.removeEventListener("ended", goToNextItem);
        videoEl.addEventListener("ended", goToNextItem);
      }
  
      return () => {
        if (videoEl) {
          videoEl.removeEventListener("ended", goToNextItem);
        }
      };
    }
  
    // Nếu là ảnh
    timeoutRef.current = setTimeout(goToNextItem, 5000);
    return () => clearTimeout(timeoutRef.current);
  }, [activeIndex]);
  

  const handleButtonClick = (index) => {
    const container = containerRef.current;
    const viewportHeight = window.innerHeight;
    container.scrollTo({
      top: index * viewportHeight,
      behavior: "smooth",
    });
    setActiveIndex(index);
  };

  return (
    <div className="relative">
      {/* Container cuộn */}
      <div
        ref={containerRef}
        className="scroll-container h-screen overflow-y-scroll snap-y snap-mandatory"
      >
        {items.map((item, index) => (
          <div
            key={item.id}
            className="scroll-item h-screen w-full flex justify-center items-center snap-start relative"
          >
            {item.type === "video" ? (
              <video
                ref={activeIndex === index ? videoRef : null}
                className="w-full h-full object-cover"
                src={isPortrait ? item.srcPortrait : item.src}
                autoPlay
                muted
                playsInline
              />
            ) : (
              <img
                className="w-full h-full object-cover"
                src={isPortrait ? item.srcPortrait : item.src}
                alt={item.alt}
              />
            )}
{/* bg-black bg-opacity-70 */}
            {item.title && (
              <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2  text-white p-8 rounded-lg max-w-lg w-full text-center ">
                {/* <h2 className="text-2xl font-semibold mb-3">{item.title}</h2> */}
                <p className="text-sm mb-4">{item.description}</p>
                <a
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white hover:text-blue-600 transition-all duration-300 underline text-2xl font-semibold"
                >
                 {item.title}
                </a>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Nút điều hướng */}
      <div className="absolute top-1/2 right-4 transform -translate-y-1/2 flex flex-col space-y-4">
        {items.map((_, index) => (
          <button
            key={index}
            onClick={() => handleButtonClick(index)}
            className={`w-4 h-4 rounded-full ${activeIndex === index ? "bg-blue-500 scale-110" : "bg-gray-300"
              } transition-transform`}
          ></button>
        ))}
      </div>
    </div>
  );
};

export default Home;

